export function formatAirportFilePeriod(period: string, subPeriod: string | null): string {
  if (subPeriod === null) return period;
  return subPeriod;
}

export function formatAirportFileCategory(category: string, subCategory: string | null): string {
  if (subCategory === null) return category;
  return `${category} - ${subCategory}`;
}
